import { RoutePaths } from './routePaths';

/**
 * Page titles mapped to route paths
 * Used for page tracking and document title management
 */
export const PageTitles = {
  [RoutePaths.HOME]: 'Movies',
  [RoutePaths.APPLIANCES]: 'Appliances',
  [RoutePaths.APPLIANCE_DETAILS]: 'Appliance Details',
  [RoutePaths.REQUESTS]: 'Requests',
  [RoutePaths.REQUEST_VIEW]: 'Request View',
  [RoutePaths.HOLDOVER_KDMS]: 'Holdover KDMs',
  [RoutePaths.USERS]: 'Users',
  [RoutePaths.USERS_LOGS]: 'Users Logs',
  [RoutePaths.ADMIN_USERS]: 'Admin Users',
  [RoutePaths.ADMIN_GROUPS]: 'Admin Groups',
  [RoutePaths.GROUPS]: 'Groups',
  [RoutePaths.GROUP_LOGS]: 'Groups Logs',
  [RoutePaths.GROUP_DETAIL]: 'Group Details',
  [RoutePaths.EDIT_GROUP]: 'Edit Group',
  [RoutePaths.GROUP_ADMIN]: 'Group Admin',
  [RoutePaths.CREATE_GROUP]: 'Create Group',
  [RoutePaths.FACILITY_DEVICES]: 'Facility Devices',
  [RoutePaths.FACILITY_SUITE_LOGS]: 'Facility Suite Logs',
  [RoutePaths.REPORTS]: 'Reports',
  [RoutePaths.WIRELINKS]: 'WireLinks',
  [RoutePaths.ERROR]: 'Error',
};

/**
 * Get page title for a given route path
 * @param {string} path - Route path
 * @returns {string} - Page title or 'Unknown Page'
 */
export function getPageTitle(path) {
  return PageTitles[path] || 'Unknown Page';
}

export default PageTitles;
